import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ResendVerificationRequestDto } from "../generated/schema";

export function useResendVerification() {
  const mutation = $api.useMutation("post", "/auth/resend-verification");

  return useMutation({
    mutationFn: async (data: ResendVerificationRequestDto) => {
      return mutation.mutateAsync({
        body: data,
        headers: {
          "x-auth-request": "true",
        },
      });
    },
  });
}
